import {
  Autocomplete,
  Box,
  colors,
  Divider,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useCommonStyles } from "../../utils";
import Checkbox from "@mui/material/Checkbox";
const CommonMultiSelectAutoComplete = ({
  label,
  size,
  value,
  options,
  placeholder,
  onChange,
  getOptionDisabled,
  fontFamily,
  fontWeight,
  fontSize,
  color,
  marginBottom,
  valid,
  labelColor
}) => {
  const { classes } = useCommonStyles();

  return (
    <div>
      {label && (
        <Box display={"flex"} gap={'2px'}>
          <InputLabel
            className={classes.label}
            sx={{
              fontWeight: fontWeight ? fontWeight : "500",
              fontSize: fontSize ? fontSize : "14px",
              fontFamily: "Satoshi-Medium",
              color: labelColor || "#2E2E30",
              marginBottom: marginBottom || "8px",
              textTransform: "capitalize",
            }}
          >
            {label}
          </InputLabel>
          {valid && (
            <Typography height={'5px'} color="#EF627A" component={"caption"} variant={"body2"}>
              *
            </Typography>
          )}
        </Box>
      )}
      <Autocomplete
        multiple
        getOptionDisabled={getOptionDisabled}
        className={classes.field}
        size={size || "small"}
        disableCloseOnSelect
        value={value}
        options={options}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={onChange}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder || "Place holder"} />
        )}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li
              key={key}
              {...optionProps}
              className={classes.option}
              options={options}
              sx={{
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
                "&.Mui-focused": {
                  backgroundColor: "#f0f0f0",
                },
              }}
            >
              <>
                <Checkbox
                  sx={{ mx: 2, my: 1 }}
                  checked={selected}
                  icon={
                    <img
                      src="/assets/img/uncheck.svg"
                      alt=""
                      style={{ height: "16px", width: "16px" }}
                    />
                  }
                  checkedIcon={
                    <img
                      src="/assets/img/check.svg"
                      alt=""
                      style={{ height: "16px", width: "16px" }}
                    />
                  }
                />
                {option.name}
                <Divider sx={{ color: "#D0D0D0" }} />
              </>
            </li>
          );
        }}
      // style={{ width: 500 }}
      />
    </div>
  );
};

export default CommonMultiSelectAutoComplete;
